import { chakra } from '@stockx/ui';

export const DropdownLinkGridContainer = chakra('div', {
  baseStyle: {
    display: 'grid',
    gridAutoRows: '1fr',
    gridTemplateColumns: '245px 245px',
    position: 'absolute',
    left: 'auto',
    width: '490px',
    zIndex: 313,
    backgroundColor: 'neutral.white',
    borderRadius: '2px',
    boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
    transform: 'translateX(calc(-100% + 52px))',

    ' a': {
      height: '100%',
      alignItems: 'center',
      display: 'inherit',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '10px 0 10px 16px !important',
      width: '245px',
      whiteSpace: 'normal',
      transition: 'none',
      '&:hover': {
        backgroundColor: 'neutral.200',
      },
      '&:nth-of-type(even)': {
        borderLeft: '1px solid',
        borderColor: 'neutral.300',
      },
    },
  },
});

export const ItemWrapper = chakra('div', {
  baseStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    ' p': {
      margin: 0,
    },

    ' p.item-title': {
      fontSize: 'sm',
      fontFamily: 'suisseIntlMedium',
      color: 'rgba(0, 0, 0, 0.87)',
      marginBottom: 1,
    },

    ' p.item-description': {
      color: 'neutral.500',
      fontSize: 'xs',
      fontFamily: 'suisseIntlMedium',
      fontWeight: 300,
      paddingRight: 2,
      height: '36px',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
    },
  },
});
